import { type FC } from "react";

import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Button } from "./button";

// The + button's width (button--icon, size-9).
export const INSERT_PLUS_WIDTH = 36;

// Insert here over the gap the pointer is on, fixed to the window from `left`
// (the +) for `width`: a round +, a dashed teal line and the pill. Only the +
// and the pill take the pointer, so the draft under the line stays his.
export const InsertGapMarker: FC<{
  top: number;
  left: number;
  width: number;
  onInsert(): void;
  onHover(hovered: boolean): void;
}> = ({ top, left, width, onInsert, onHover }) => {
  const hover = {
    onMouseEnter: () => onHover(true),
    onMouseLeave: () => onHover(false),
  };

  return (
    <div
      className="pointer-events-none fixed z-20 flex items-center"
      style={{ top: top - 18, left, width }}
    >
      <span className="pointer-events-auto">
        <Button
          type="button"
          color="indigo"
          size="icon"
          aria-label="Insert section here"
          onClick={onInsert}
          {...hover}
        >
          <FontAwesomeIcon icon={faPlus} />
        </Button>
      </span>
      <span className="ml-3 h-0 flex-1 border-t-2 border-dashed border-teal-500" />
      <span className="pointer-events-auto absolute left-12">
        <Button
          type="button"
          color="outline"
          size="xs"
          onClick={onInsert}
          {...hover}
        >
          Insert section here
        </Button>
      </span>
    </div>
  );
};
